// export default () => {
//     let StorageUtil = function () {};

//     StorageUtil.prototype.getSessionStorage = function () {
//         let sStorage = false;
//         try {
//             sStorage = window.sessionStorage; // This will throw an exception in some browsers when cookies/localStorage are explicitly disabled (i.e. Chrome)
//             sStorage.setItem('TEST', '1');
//             sStorage.removeItem('TEST');
//         } catch (e) {
//             sStorage = false;
//         }
//         return sStorage;
//     };

//     StorageUtil.prototype.getLocalStorage = function () {
//         let lStorage = false;
//         try {
//             lStorage = window.localStorage; // This will throw an exception in some browsers when cookies/localStorage are explicitly disabled (i.e. Chrome)
//             lStorage.setItem('TEST', '1');
//             lStorage.removeItem('TEST');
//         } catch (e) {
//             lStorage = false;
//         }
//         return lStorage;
//     };

//     return new StorageUtil();
// }
export default {
    getSessionStorage: function() {
        let sStorage = false;
        try {
            sStorage = sessionStorage; // This will throw an exception in some browsers when cookies/localStorage are explicitly disabled (i.e. Chrome)
            sStorage.setItem('TEST', '1');
            sStorage.removeItem('TEST');
        } catch (e) {
            sStorage = false;
        }
        return sStorage;
    },
    getLocalStorage: function() {
        let lStorage = false;
        try {
            lStorage = localStorage; // This will throw an exception in some browsers when cookies/localStorage are explicitly disabled (i.e. Chrome)
            lStorage.setItem('TEST', '1');
            lStorage.removeItem('TEST');
        } catch (e) {
            lStorage = false;
        }
        return lStorage;
    }
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/storage.js